import React from "react";
const CheckedContext = /*#__PURE__*/React.createContext();
export const useCheckedContextProps = props => {
  const ctx = React.useContext(CheckedContext) || {};
  const individualCheckedControlled = typeof props.checked !== 'undefined';

  const getCheckedValue = () => {
    if (individualCheckedControlled) {
      return props.checked;
    }

    if (ctx.isChecked) return ctx.isChecked(props.value);
    return false;
  };

  return {
    onChange: evt => {
      if (!individualCheckedControlled && ctx.onChange) ctx.onChange(evt);
      if (props.onChange) props.onChange(evt);
    },
    checked: getCheckedValue(),
    value: props.value
  };
};
export const CheckedProvider = CheckedContext.Provider;